// import img from "../images/vet/mfban_ratio.jpeg";
import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";
import notice_2 from "../images/resource/images/스카이현판.jpeg";
import notice_3 from "../images/resource/images/스카이유기동물사료.jpeg";
import notice_4 from "../images/resource/images/구월지웰시티푸르지오_인천스카이동물메디컬센터_주차_안내_1.jpeg";
import notice_5 from "../images/title/visual_incheon.jpeg";
import notice_6 from "../images/resource/images/진료비안내_원주점.PNG";
import bannerImg2025092902 from "../images/popup/wj_2025092902.png";

// import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";
// import notice_1 from "../images/resource/images/코벳엑스칼리버.jpeg";

//? 관련 이미지가 없는 경우, 빈 문자열 넣어주세요

const notice = [
  {
    id: 6,
    title: `진료비 안내`,
    content: `안녕하세요.
원주SKY동물메디컬센터입니다.

원주SKY동물메디컬센터 진료비에 대해 안내드립니다.

앞으로 더욱 노력하는 SKY동물메디컬그룹이 되겠습니다.
감사합니다.

수의사법 제 320조(진찰 등의 진료비용 게시) 및 수의사법 시행규칙 제18조의 3
(진찰 등의 진료비용 게시 대상 및 방법)에 다라 다음과 같이 고지합니다.
`,
    img: notice_6,
  },
  {
    id: 7,
    title: `진료 시간 안내`,
    content: `안녕하세요.
원주SKY동물메디컬센터입니다.

원주SKY동물메디컬센터 진료 일정 변동 사항에 대해 안내드립니다.

감사합니다.

※ 회진시간(PM 13:00~14:00) 동안은 진료가 어렵습니다.
진료가 지연될 수 있는 점 많은 양해 부탁드립니다.
`,
    img: bannerImg2025092902,
  },
];

export default notice;
